module.exports = __webpack_public_path__ + "static/media/event-services-img41.5b6e2674.jpg";